import { TIPO_ORIGEM } from 'src/utils/constants';

const TIPOS_ORIGEM_FILTRO_ACAO = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  16,
  19,
  20,
  21,
  23,
  24,
  TIPO_ORIGEM.PESQUISA_CLIMA,
  TIPO_ORIGEM.OCORRENCIA,
];

export default TIPOS_ORIGEM_FILTRO_ACAO;
